import React from 'react'
import MyPayroll from './MyPayroll'


export default function StudentRequestApprovalReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
